import { Link } from 'react-router-dom';
import { routes } from '../../config/links';
import styles from './NavDropdown.module.css';

interface NavDropdownProps {
  label: string;
  onNavigate?: () => void;
}

function NavDropdown({ label, onNavigate }: NavDropdownProps) {
  return (
    <div className={styles.dropdown}>
      <span className={styles.trigger} aria-haspopup="true">
        {label}
        <span className={styles.chevron} aria-hidden="true" />
      </span>
      <div className={styles.menu} role="menu">
        <Link
          to={routes.solutions}
          className={styles.menuItem}
          role="menuitem"
          onClick={onNavigate}
        >
          Stadiums &amp; Arenas
        </Link>
        <Link
          to={routes.solutionsConcertVenues}
          className={styles.menuItem}
          role="menuitem"
          onClick={onNavigate}
        >
          Concert Venues
        </Link>
      </div>
    </div>
  );
}

export default NavDropdown;
